import React from 'react';
import {DisplayText} from '@shopify/polaris';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {ParentCategories} from 'sections/services-marketplace/experts/components';

import styles from './ParentCategoriesContainer.scss';

interface OwnProps {}

type CombinedProps = OwnProps & WithI18nProps;

export function ParentCategoriesContainer({i18n}: CombinedProps) {
  return (
    <div className={styles.ParentCategoriesContainer}>
      <div className={styles.CollectionHeading}>
        <DisplayText size="large" element="h2">
          {i18n.translate('Home.ParentServiceGroups.title')}
        </DisplayText>
      </div>
      <ParentCategories />
    </div>
  );
}

export default withI18n()(ParentCategoriesContainer);
